/**
 * FORJA — movimento e carregamento de imagem.
 *
 * Resolve três coisas que doíam no celular:
 *
 *   1. "estalo" das imagens — a imagem lazy chega tarde e aparece de repente.
 *      A solução NÃO é escondê-la até carregar (isso só troca o estalo de
 *      lugar): é buscá-la cedo, para que já esteja pronta na hora de aparecer.
 *   2. seção preta que demora — o lazy nativo só começa a baixar quando a
 *      imagem está quase entrando na tela; no celular isso é tarde demais e
 *      você vê o bloco preto antes da imagem. Aqui a imagem é promovida a
 *      eager duas telas antes, então na hora de chegar nela já está pronta.
 *
 * Regras de segurança que guiam o arquivo inteiro:
 *   - nada fica escondido por CSS estático. Quem esconde é este script; se ele
 *     não rodar, a página aparece inteira e normal.
 *   - o que já está visível no primeiro paint nunca é escondido nem animado
 *     (não atrasa LCP, não pisca).
 *   - prefers-reduced-motion desliga tudo.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------------
     1. Imagens: fade na chegada + busca antecipada.
     -------------------------------------------------------------------- */
  function setupImages(root) {
    var imgs = root.querySelectorAll('img[loading="lazy"]:not([data-forja-img])');
    if (!imgs.length) return;

    var pending = [];

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('data-forja-img', '');

      if (img.complete && img.naturalWidth > 0) continue;

      pending.push(img);
    }

    if (!pending.length) return;

    /* Sem IntersectionObserver, promove tudo: melhor baixar cedo do que
       assistir a imagem entrar na tela. */
    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < pending.length; j++) promote(pending[j]);
      return;
    }

    /* 200% = duas alturas de tela de antecedência. */
    var warm = new IntersectionObserver(
      function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) continue;
          promote(entries[k].target);
          warm.unobserve(entries[k].target);
        }
      },
      { rootMargin: '200% 0px 200% 0px' }
    );

    for (var m = 0; m < pending.length; m++) warm.observe(pending[m]);
  }

  /**
   * Tira o `loading="lazy"`, o que faz o navegador buscar a imagem na hora.
   *
   * O cuidado com `sizes="auto"`: por spec ele só vale junto de lazy. Ao virar
   * eager, o `auto` é descartado e o navegador cai no resto da lista de sizes —
   * que costuma ser `100vw`, largo demais, e aí a promoção baixaria um arquivo
   * MAIOR do que o lazy baixaria. Então antes de promover a gente congela em
   * `sizes` a largura que o `auto` teria resolvido: a largura de layout da
   * imagem, que já existe mesmo sem o arquivo ter chegado.
   */
  function promote(img) {
    var sizes = img.getAttribute('sizes') || '';

    if (/(^|,)\s*auto\s*(,|$)/i.test(sizes)) {
      var w = img.getBoundingClientRect().width;
      if (!w) return; // sem caixa medível, deixa o lazy nativo cuidar
      img.setAttribute('sizes', Math.round(w) + 'px');
    }

    img.setAttribute('loading', 'eager');
  }


  /* -------------------------------------------------------------------- */

  function init(root) {
    setupImages(root);
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* O editor de tema re-renderiza seções soltas. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
